import React from 'react'

import { Menu, Tag } from 'antd'
import styled from 'styled-components'

import { CheckboxRadioField } from '../../../../types/blueprint'

import { checkboxPresets } from './presetsCheckbox'
import { radioPresets } from './presetsRadio'

import {
  ListModal,
  Column,
  MODAL_Z_INDEX,
} from '@/components/form-components/ListModal'
import { Dropdown } from '@/components/shared-components/BUI/Dropdown'

const DesiredStateTag = styled(Tag)`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin: 0;
`

const DESIRED_STATES = {
  null: {
    value: 'null',
    label: 'Either',
    colour: undefined,
  },
  true: {
    value: 'true',
    label: 'Checked',
    colour: 'green',
  },
  false: {
    value: 'false',
    label: 'Unchecked',
    colour: 'red',
  },
}

const desiredMenu = (desiredState: string, onClick) => (
  <Menu
    onClick={(selected) => onClick(selected.key)}
    selectedKeys={[desiredState]}
  >
    <Menu.Item key={DESIRED_STATES.null.value}>
      {DESIRED_STATES.null.label}
    </Menu.Item>
    <Menu.Item key={DESIRED_STATES.true.value}>
      {DESIRED_STATES.true.label}
    </Menu.Item>
    <Menu.Item key={DESIRED_STATES.false.value}>
      {DESIRED_STATES.false.label}
    </Menu.Item>
  </Menu>
)

const DesiredDropdown = ({ value, onChange }) => {
  const desiredStateConfig = (desiredState) => {
    if (desiredState === undefined) return DESIRED_STATES.null
    return DESIRED_STATES[`${desiredState}`] || DESIRED_STATES.null
  }

  const decodeDesiredState = (selected: string) => {
    if (selected === DESIRED_STATES.null.value) return onChange(null)
    if (selected === DESIRED_STATES.true.value) return onChange(true)
    return onChange(false)
  }

  const desired = desiredStateConfig(value)

  return (
    <Dropdown
      trigger={['click']}
      overlay={desiredMenu(value, decodeDesiredState)}
      overlayStyle={{ zIndex: MODAL_Z_INDEX + 1 }}
    >
      <DesiredStateTag color={desired.colour}>{desired.label}</DesiredStateTag>
    </Dropdown>
  )
}

const COLUMNS: Column[] = [
  {
    name: 'label',
    label: 'Label',
    inputType: 'text',
    defaultValue: '',
  },
  {
    name: 'desiredState',
    label: 'Desired',
    render: DesiredDropdown,
    defaultValue: null,
  },
]

type Props = {
  value: CheckboxRadioField[]
  onChange: (value: CheckboxRadioField[]) => void
  type: 'checkbox' | 'radio'
}

export const CheckboxRadioInput: React.FC<Props> = ({
  value,
  onChange,
  type,
}) => {
  return (
    <ListModal
      columns={COLUMNS}
      value={value}
      onChange={onChange}
      buttonText="Edit values"
      modalTitle="Configure values"
      presets={type === 'checkbox' ? checkboxPresets : radioPresets}
      dataTestId="select-edit-values-button"
    />
  )
}
